import { SpecBatteryIcon, specBatteryColor } from './ListingSpecIcons'

export function sanitizeBatteryHealthInput(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return ''
  const n = parseInt(digits, 10)
  if (!Number.isFinite(n)) return ''
  return String(Math.min(100, Math.max(0, n)))
}

function batteryKnown(value: string): boolean {
  const trimmed = value.trim()
  const parsed = parseInt(trimmed, 10)
  return trimmed !== '' && Number.isFinite(parsed)
}

function levelFromValue(value: string, fallback: number): number {
  const trimmed = value.trim()
  const parsed = parseInt(trimmed, 10)
  if (trimmed === '' || !Number.isFinite(parsed)) return fallback
  return Math.min(100, Math.max(0, parsed))
}

type Props = {
  value: string
  onChange: (value: string) => void
  ariaLabel?: string
}

/** Editable battery % pill — same layout as cycles chip in builder spec row. */
export default function BatteryHealthValueChip({
  value,
  onChange,
  ariaLabel = 'Battery health',
}: Props) {
  const known = batteryKnown(value)
  const level = levelFromValue(value, 100)
  const tone = specBatteryColor(level)

  return (
    <span
      className={`listing-spec-value-chip listing-spec-value-chip--battery battery-health-chip-shell${
        known ? '' : ' listing-spec-value-chip--muted battery-health-chip-shell--empty'
      }`}
      style={known ? { color: tone, borderColor: `${tone}55` } : undefined}
    >
      <SpecBatteryIcon level={level} size={18} />
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        className="battery-cycles-chip-input battery-health-chip-input"
        value={value}
        maxLength={3}
        placeholder=""
        onChange={(e) => onChange(sanitizeBatteryHealthInput(e.target.value))}
        aria-label={ariaLabel}
      />
    </span>
  )
}
